import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { NectarTheme } from "@nectarTypes";
import { Text } from "nectar-ui";

export const Container = styled.div<NectarTheme>`
  ${({ theme }) => css`
    z-index: 5;
    grid-area: topNav;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${theme.spacings.sm} ${theme.spacings.lg};
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
  `}
`;

export const BackButtonContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;

    ${theme.breakpoints.md} {
      display: none;
    }
  `}
`;

export const BurgerButtonContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    height: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: ${theme.spacings.xs};
    cursor: pointer;

    ${theme.breakpoints.md} {
      display: none;
    }
  `}
`;

export const MenuText = styled(Text)`
  font-weight: 600;
  font-size: 0.75rem;
`;

export const TopContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    background-color: ${theme.colors.gray100};
    height: 62px;
    align-items: center;
    justify-content: flex-end;
    padding: ${theme.spacings.xs} ${theme.spacings.lg};
    margin-bottom: ${theme.spacings.lg};
  `}
`;

export const CloseContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    column-gap: ${theme.spacings.xs};
    display: flex;
    align-items: center;
    cursor: pointer;
  `}
`;

export const MenuContainer = styled.div<{ isOpen: boolean }>`
  ${({ isOpen }) => css`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: ${isOpen ? "100%" : 0};
    background-color: #ffffff;
    transition: all 0.3s ease-in-out;
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    text-wrap: nowrap;
    overflow-y: hidden;
    z-index: 1;
  `}
`;

export const IconContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: none;

    & img {
      height: 60px;
    }

    ${theme.breakpoints.md} {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `}
`;
